module.exports = __webpack_public_path__ + "static/img/Chanel-Harris-Tavita.bab12e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chanel-Harris-Tavita.jpg
// module id = 0zlR
// module chunks = 0